<template>

<div tabindex="0" class="e-card" id="price">
  <div class="e-card-title" style="display: inline-block">New Permit Price</div>
    <div>
      <div class="e-card-content">
        <div class="form-row"  v-if="!canChangeProductType">
          <div style="width:80%;" class="form-row-input">
          Product Type: {{productDescription}}
          </div>
        </div>

        <div class="form-row" v-if="canChangeProductType">
          <div style="width:80%;" class="form-row-input">
            <ejs-dropdownlist
            float-label-type="Always"
            :dataSource='productTypes'
            :fields='productTypeFields'
            placeholder='Select a product'
            v-model='productId' >
            </ejs-dropdownlist>
          </div>
        </div>

        <div class="form-row">
          <div style="width:40%;" class="form-row-input">
            <ejs-dropdownlist
              float-label-type="Always"
              :dataSource='chargeByOptions'
              :fields='chargeByFields'
              :change='onChargeByChange'
              placeholder='Charge By'
              v-model='chargeBy' >
            </ejs-dropdownlist>
          </div>
        </div>

        <div class="form-row">
          <div style="width:10%;" class="form-row-input">
            <scc-input-validator
            :rules="[positiveNumberRule]"
            :number="this.amountApp"
            @validate="(v) => (this.isAmountAppValid = v)"
            >
              <ejs-numerictextbox
              float-label-type="Always"
              placeholder="Per Application*"
              format="C2"
              :disabled="DisableAmountApp()"
              :showSpinButton='spin'
              v-model="amountApp" />
            </scc-input-validator>
          </div>
        </div>

        <div class="form-row">
          <div style="width:10%;" class="form-row-input">
            <scc-input-validator
              :rules="[positiveNumberRule]"
              :number="this.amountTank"
              @validate="(v) => (this.isAmountTankValid = v)"
            >
              <ejs-numerictextbox
              float-label-type="Always"
              placeholder="Per Tank*"
              format="C2"
              :disabled="DisableAmountTank()"
              :showSpinButton='spin'
              v-model="amountTank" />
            </scc-input-validator>
          </div>
        </div>

        <div class="form-row">
          <div style="width:10%;" class="form-row-input">
            <div style="flex:3;">
              <scc-input-validator
                :rules="[positiveNumberRule]"
                :number="this.amountLevy"
                @validate="(v) => (this.isAmountLevyValid = v)"
              >
                <ejs-numerictextbox
                float-label-type="Always"
                placeholder="Levy*"
                format = 'C2'
                :showSpinButton='spin'
                v-model="amountLevy" />
              </scc-input-validator>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div style="width:20%;" class="form-row-input">
            <ejs-datepicker
            float-label-type="Always"
            v-model="effectiveStartDate"
            :placeholder="dateMarker"
            :min="minVal"
            :max="maxVal"
            :format="dateFormat"/>
          </div>
        </div>

        <div class="align-center-bottom">
        <ejs-button type="button" v-on:click.native="onSubmitButtonClick"
                      cssClass="e-info margin-button">Submit</ejs-button>
        <ejs-button v-on:click.native="onCancelButtonClick"
                      cssClass="e-danger margin-button">Cancel</ejs-button>
        </div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue';

import { TextBoxPlugin, NumericTextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import { RadioButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import SccInputValidator from '@/components/base/scc-input-validator.vue';

import { POST_PRODUCT_PRICE, FETCH_PRODUCT_PRICE } from '../store';

Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(DatePickerPlugin);
Vue.use(RadioButtonPlugin);

export default {
  name: 'AddPermitPrice',
  components: {
    SccInputValidator,
  },

  data() {
    return {
      priceId: null,
      title: 'New Price',
      productId: null,
      productType: '',
      amountApp: 0,
      amountTank: 0,
      amountLevy: 0,
      amountPerAddress: 0,
      chargeBy: '',
      effectiveStartDate: null,
      allowChangeProductType: true,
      productDescription: '',
      dateMarker: 'Select Start Date(yyyy-mm-dd)',
      dateFormat: 'yyyy-MM-dd',
      productTypes: [],
      productTypeFields: { text: 'productDescription', value: 'productId' },
      hideChargeBy: true,

      chargeByOptions: [],
      chargeByFields: { text: 'chargeBy', value: 'chargeBy' },

      levyFeeType: null,
      levyFeeTypes: [{ label: 'percentage', value: '%' }, { label: 'amount', value: '$' }],
      positiveNumberRule: {
        regEx: '^(\\+)?\\d+(\\.\\d*)?$',
        message: 'Please provide a positive amount.',
      },
      isAmountAppValid: false,
      isAmountTankValid: false,
      isAmountLevyValid: false,
      spin: false,
    };
  },

  created() {
    this.productTypes = this.$store.getters.productTypes.filter((x) => x.productType === 'Permit');
    // To Add Filter to the options
    this.chargeByOptions = this.$store.getters.chargeByOptions.filter((x) => x.productType === 'Permit');

    if (this.$route.params.id !== '0') {
      this.priceId = this.$route.params.id;
      this.allowChangeProductType = false;
      this.FetchProductPrice();
    } else {
      this.priceId = '';
    }
  },

  computed: {
    canChangeProductType() {
      return this.allowChangeProductType;
    },
    minVal() {
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth();
      const currentDay = today.getDate() + 1;
      return new Date(currentYear, currentMonth, currentDay);
    },
    maxVal() {
      const today = new Date();
      const currentYear = today.getFullYear() + 2;
      const currentMonth = today.getMonth();
      const currentDay = today.getDate();
      return new Date(currentYear, currentMonth, currentDay);
    },
  },

  methods: {

    DisableAmountApp() {
      if (this.chargeBy === 'Each Tank') return true;

      return false;
    },

    DisableAmountTank() {
      if (this.chargeBy === 'Application') return true;

      return false;
    },

    ValidateAmounts() {
      if (this.chargeBy === 'Both' || this.chargeBy === 'Application') {
        this.amountApp = this.amountapp == null ? 0 : this.amountApp;
      }

      if (this.chargeBy === 'Both' || this.chargeBy === 'Tank') {
        this.amountTank = this.amountTank == null ? 0 : this.amountTank;
      }
      this.amountLevy = this.amountLevy == null ? 0 : this.amountLevy;
    },

    onChargeByChange() {
      if (this.chargeBy === 'Application') {
        this.amountTank = 0;
      }

      if (this.chargeBy === 'Each Tank') {
        this.amountApp = 0;
      }
    },

    getProductDescription() {
      const product = this.productTypes.find((x) => x.productId === this.productId);
      return product.productDescription;
    },

    onCancelButtonClick() {
      this.$router.push('/products/productprices/');
    },

    async onSubmitButtonClick(e) {
      // console.log('productid', this.productId);
      if (this.productId === null || this.productId === '') {
        e.cancel = true;
        this.$parent.$parent.notificationToasts.push({
          title: 'Error!',
          content: 'Please select a product type first!',
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
        this.$parent.$parent.$refs.notifierRef.show();
        return;
      }
      let formDataFail = false;
      /// checking values meeting rules
      let errorMessage = '';
      if (this.chargeBy === 'Both') {
        if (this.amountApp === null || this.amountApp === '' || this.amountApp === 0) {
          formDataFail = true;
          errorMessage = 'Please check Per Application amount values!<br>';
        } else {
          this.isAmountAppValid = true;
        }
        if (this.amountTank === null || this.amountTank === '' || this.amountTank === 0) {
          formDataFail = true;
          errorMessage += 'Please check Per Tank amount values!<br>';
        } else {
          this.isAmountTankValid = true;
        }
      } else if (this.chargeBy === 'Application') {
        this.isAmountTankValid = true;
        if (this.amountApp === null || this.amountApp === '' || this.amountApp === 0) {
          formDataFail = true;
          errorMessage = 'Please check Per Application amount values!<br>';
        } else {
          this.isAmountAppValid = true;
        }
      } else if (this.chargeBy === 'Each Tank') {
        this.isAmountAppValid = true;
        if (this.amountTank === null || this.amountTank === '' || this.amountTank === 0) {
          formDataFail = true;
          errorMessage = 'Please check Per Tank amount values!<br>';
        } else {
          this.isAmountTankValid = true;
        }
      }

      this.isAmountLevyValid = true;
      if (this.effectiveStartDate === null) {
        formDataFail = true;
        errorMessage += 'Please select start date!<br>';
      }
      if (formDataFail) {
        this.$parent.$parent.notificationToasts.push({
          title: 'Error!',
          content: errorMessage,
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
        this.$parent.$parent.$refs.notifierRef.show();
        return;
      }
      if (this.isAmountAppValid && this.isAmountTankValid && this.isAmountLevyValid) {
        try {
          const data = {};
          if (this.priceId !== null && this.priceId !== '') {
            data.priceId = this.priceId;
          }
          data.productId = this.productId;
          data.amountApp = this.amountApp;
          data.amountTank = this.amountTank;
          data.amountLevy = this.amountLevy;
          data.amountPerAddress = this.amountPerAddress;
          data.levyFeeType = this.levyFeeType;
          data.chargeBy = this.chargeBy;
          data.effectiveStartDate = this.effectiveStartDate;
          await this.$store.dispatch(POST_PRODUCT_PRICE, { data });
          this.$parent.$parent.notificationToasts.push({
            title: 'Success!',
            content: 'Product price saved.',
            cssClass: 'e-toast-success',
            timeOut: 5000,
          });
          this.$router.push('/products/productprices/');
        } catch (error) {
          console.error(error);
        }
      } else {
        this.$parent.$parent.notificationToasts.push({
          title: 'Error!',
          content: 'Please verify the form data.',
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
      }
      if (this.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$refs.notifierRef.show();
      }
    },

    async FetchProductPrice() {
      if (this.priceId != null && this.priceId !== '' && this.priceId !== '0') {
        const { priceId } = this;
        await this.$store.dispatch(FETCH_PRODUCT_PRICE, { priceId });

        const {
          productId, amountApp, amountTank, amountLevy, amountPerAddress,
          levyFeeType, chargeBy, effectiveStartDate, effectiveEndDate,
        } = this.$store.getters.currentPrice;
        this.productId = productId;
        this.amountApp = amountApp;
        this.amountTank = amountTank;
        this.amountLevy = amountLevy;
        this.amountPerAddress = amountPerAddress;
        this.levyFeeType = levyFeeType;
        this.chargeBy = chargeBy;
        this.effectiveStartDate = effectiveStartDate;
        this.effectiveEndDate = effectiveEndDate;
        this.productDescription = this.getProductDescription();
      }
    },
  },

};
</script>

<style>
 @import '../../../assets/styles/eservices-base.css';
 .e-card-content {
  margin: 0% !important;
}
</style>
